// web-vitals v5+ attribution build: alem das metricas basicas, expoe
// metric.attribution com diagnostico (target/loaf/inputDelay para INP,
// element/url para LCP, sources para CLS). Atribuicao adiciona ~1KB e e
// essencial para acionar a investigacao de "qual interacao eh lenta".
const reportWebVitals = (onPerfEntry) => {
  if (!onPerfEntry || typeof onPerfEntry !== 'function') return;
  import('web-vitals/attribution')
    .then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
      try { onCLS(onPerfEntry); } catch {}
      try { onINP(onPerfEntry, { reportAllChanges: false }); } catch {}
      try { onLCP(onPerfEntry); } catch {}
      try { onFCP(onPerfEntry); } catch {}
      try { onTTFB(onPerfEntry); } catch {}
    })
    .catch(() => {});
};

export default reportWebVitals;
